import React from 'react';
import { Section } from './ui/Section';
import { Check } from 'lucide-react';
import { Button } from './ui/Button';
import { trackAddToCart } from '../utils/metaPixel';
export function WhatYouGet() {
  const items = ['eBook completo 60+ páginas: 7 capítulos detallados', '5 movimientos Core Latino paso-paso (fotos descriptivas)', 'Menú 21 días swaps latinos (semana 1 detox, 2 quema, 3 fija)', 'Checklists diarios tracking (foto/medidas)', 'Worksheets acción (diagnóstico, plan personal)', 'Bonus audio 5min anti-culpa', "Lista supermercados USA (Walmart/Publix/Sedano's)", 'FAQ 8 dudas reales mamás', 'Glossary + resources'];
  return <Section className="bg-[#FFF0EB]" data-id="element-166">
      <div className="max-w-4xl mx-auto bg-white rounded-3xl shadow-xl overflow-hidden" data-id="element-167">
        <div className="p-8 md:p-12" data-id="element-168">
          <h2 className="text-3xl md:text-4xl font-bold text-[#0D5C63] mb-8 text-center font-serif" data-id="element-169">
            ¿Qué Incluye?
          </h2>

          <div className="grid md:grid-cols-2 gap-x-8 gap-y-4" data-id="element-170">
            {items.map((item, index) => <div key={index} className="flex items-start" data-id="element-171">
                <div className="bg-green-100 rounded-full p-1 mr-3 mt-1 flex-shrink-0" data-id="element-172">
                  <Check className="w-4 h-4 text-green-600" data-id="element-173" />
                </div>
                <span className="text-[#2D2D2D] font-medium" data-id="element-174">{item}</span>
              </div>)}
          </div>

          <div className="mt-12 text-center" data-id="element-175">
            <Button onClick={() => {
            trackAddToCart();
            window.open('https://coreeveryday.com/cart/48302469382363:1', '_blank');
          }} data-id="element-176">
              COMPRAR AHORA POR $6.36
            </Button>
          </div>
        </div>
      </div>
    </Section>;
}